import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	ArcElement,
	Title,
	Tooltip,
	Legend,
	PointElement,
	LineElement,
	Filler,
	TimeScale,
	LogarithmicScale,
} from 'chart.js';

import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
	LogarithmicScale,
	CategoryScale,
	LinearScale,
	BarElement,
	ArcElement,
	Title,
	Tooltip,
	Legend,
	PointElement,
	LineElement,
	Filler,
	TimeScale,
	ChartDataLabels,
);

ChartJS.defaults.font.family = 'Greed Standard';
